import { render, staticRenderFns } from "./PhoneSimManageList.vue?vue&type=template&id=c82a7624&scoped=true"
import script from "./PhoneSimManageList.vue?vue&type=script&lang=js"
export * from "./PhoneSimManageList.vue?vue&type=script&lang=js"
import style0 from "./PhoneSimManageList.vue?vue&type=style&index=0&id=c82a7624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82a7624",
  null
  
)

export default component.exports